export default "__VITE_ASSET__c9648e43__"